// extracted by mini-css-extract-plugin
export default {"loaderback":"loader_loaderback__xF54V","loader":"loader_loader__1AOoV","spin":"loader_spin__jlXXz"};